import React from 'react';

import Typography from '@material-ui/core/Typography';

export const firebaseLooper = (snapshot) => {
  const data = [];

  snapshot.forEach((childSnapshot) => {
    data.push({
      ...childSnapshot.val(),
      id: childSnapshot.key
    })
  });
  return data
}

export function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

export const reverseArray = (actualArray) => {
  let reversedArray = [];

  for(let i = actualArray.length - 1; i >= 0; i--){
    reversedArray.push(actualArray[i])
  }

  return reversedArray;
}

export const validate = (element) => {
  let error = [true, ''];

  if(element.validation.email){
    const valid = /\S+@\S+\.\S+/.test(element.value);
    const message = `${!valid ? 'Неправильный майл' : ''}`;

    error = !valid ? [valid, message]: error
  }

  if(element.validation.required){
    const valid = element.value.trim() !== '';
    const message = `${!valid ? 'Поле должно быть заполненно' : ''}`;

    error = !valid ? [valid, message]: error
  }

  return error;
}